import React from 'react';
import { Layout, Avatar, Dropdown, Typography, Button } from 'antd';
import {
  UserOutlined,
  LogoutOutlined,
  SettingOutlined,
  MenuOutlined,
  SunOutlined,
  MoonOutlined,
  CrownOutlined,
} from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import useAuthStore from '../../store/authStore';
import useThemeStore from '../../store/themeStore';

const { Header: AntHeader } = Layout;

const Header = ({ collapsed, onToggle }) => {
  const navigate = useNavigate();
  const { user, logout } = useAuthStore();
  const { theme, toggleTheme } = useThemeStore();
  const isDark = theme === 'dark';

  const isAdmin = user?.role === 'super_admin' || user?.role === 'tenant_admin';

  const handleLogout = async () => {
    await logout();
    window.location.href = '/login';
  };

  const userMenuItems = [
    {
      key: 'profile',
      icon: <UserOutlined />,
      label: 'My Profile',
      onClick: () => navigate('/profile'),
    },
    {
      key: 'settings',
      icon: <SettingOutlined />,
      label: 'Settings',
      onClick: () => navigate('/settings'),
    },
    ...(isAdmin
      ? [
          {
            key: 'admin-settings',
            icon: <CrownOutlined />,
            label: 'Admin Settings',
            onClick: () => navigate('/admin/settings'),
          },
        ]
      : []),
    { type: 'divider' },
    {
      key: 'logout',
      icon: <LogoutOutlined />,
      label: 'Sign out',
      danger: true,
      onClick: handleLogout,
    },
  ];

  return (
    <AntHeader 
      className="bg-white dark:bg-gray-800 border-b border-gray-200 dark:border-gray-700 px-4 flex items-center justify-between shadow-soft"
      style={{ padding: '0 24px', height: '64px' }}
    >
      {/* Left side - Menu toggle and breadcrumb */}
      <div className="flex items-center space-x-4">
        <Button
          type="text"
          icon={<MenuOutlined />}
          onClick={onToggle}
          className="touch-target focus-visible:focus"
          aria-label={collapsed ? 'Expand sidebar' : 'Collapse sidebar'}
        />
        
      </div>

      {/* Right side - Actions and user menu */}
      <div className="flex items-center space-x-4">
        {/* Theme toggle */}
        <Button
          type="text"
          icon={isDark ? <SunOutlined /> : <MoonOutlined />}
          onClick={toggleTheme}
          className="touch-target focus-visible:focus"
          aria-label={`Switch to ${isDark ? 'light' : 'dark'} theme`}
        />

        {/* Notifications */}
        {/* <NotificationCenter /> */}

        {/* User menu */}
        <Dropdown
          menu={{ items: userMenuItems }}
          placement="bottomRight"
          trigger={['click']}
        >
          <Button
            type="text"
            className="flex items-center space-x-2 touch-target focus-visible:focus"
            aria-label="User menu"
          >
            <Avatar
              size="small"
              icon={<UserOutlined />}
              src={user?.avatar}
              alt={user?.fullName || 'User avatar'}
              style={{
                background: 'linear-gradient(135deg, #1e40af, #3b82f6)',
                color: '#fff',
                boxShadow: '0 4px 12px -4px rgba(59,130,246,0.6)',
              }}
            />
            <div className="hidden md:block">
              <div className="text-sm font-medium text-gray-900 dark:text-gray-100">
                {user?.fullName || 'User'}
              </div>
              <div className="text-xs text-gray-500 dark:text-gray-400">
                {user?.role?.replace('_', ' ').toUpperCase()}
              </div>
            </div>
          </Button>
        </Dropdown>
      </div>
    </AntHeader>
  );
};

export default Header;
